<template>
  <app-base-main parentTable no-padding>
    <template #filter-group>
      <app-filter-group
          @reset="$gjReset"
          @query="$gjNoticeQuery"
      >
        <gj-country-server-select
            v-model="filter.countryAndMarket"
        ></gj-country-server-select>
        <gj-select
            v-model="filter.currency"
            :options="financeProfitReport"
            :clearable="false"
        ></gj-select>
        <gj-select-input
            :value="filter.keyword"
            :options="keywordOptions"
        >
        </gj-select-input>
        <gj-select
            v-model="filter.type"
            :options="feeTypeOption"
            placeholder="全部费用类型"
            width="150px"
        >
        </gj-select>
        <gj-date-picker
            v-model="filter.date"
            type="daterange"
            :clearable="false"
        ></gj-date-picker>
        <!-- <gj-category-select
              multiple
              v-model="filter.category"
              width="150px"
          >
          </gj-category-select> -->
        <template #advancedFilter>
          <gj-category-select
              multiple
              v-model="filter.category"
              width="150px"
          >
          </gj-category-select>
        </template>
      </app-filter-group>
    </template>
    <template #operate-group>
<!--      <div style="width: 1px;height: 16px;"></div>-->
      <gj-button type="primary" @click="openImport">导入日期范围报告</gj-button>
<!--      <gj-button @click="openImportRecord">导入记录</gj-button>-->
      <div style="display: inline-block">
        <gj-text-alert type="info" iconColor="#999">
            注意：建议相关店铺使用谷歌浏览器安装积加云助手浏览器插件，实现数据每天自动同步，具体安装方式参考
            <gj-link href="http://help.gerpgo.com/web/#/26?page_id=633" target="_blank">帮助文档</gj-link>
            或联系客服
        </gj-text-alert>
      </div>
      <br>
      <span class="colorRed" style="font-size: 12px;">导入记录已迁移至亚马逊报表模块</span>
    </template>
    <template #tool-group>
      <gj-tool-group
          setting
          :sort-gjtable="$refs.gjTable"
          :table-name="tableName"
          :table-columns="columns"
          help
          download
          download-url="/finance/financialProfitAnalysis/exportDateRange"
          :download-params="globalParams"
      ></gj-tool-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :data="data"
          :columns="columns"
          :pagination="pagination"
          :loading="loading"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery"
      >
        <template v-slot:description="{ row }">
          <gj-tooltip :text-line="2" :content="row.description">{{row.description}}</gj-tooltip>
        </template>
        <template v-slot:productName="{ row }">
          <div>
            <gj-tooltip :text-line="1" :content="row.productName">{{row.productName || '-'}}</gj-tooltip>
          </div>
          <el-row>
            <el-col :span="20">
              <gj-tooltip :text-line="1" :content="row.sku">{{row.sku}}</gj-tooltip>
            </el-col>
            <el-col :span="4">
              <span v-copy="row.sku"
                    class="copy-icon gj-cell-display-switch">
                <gj-icon class="el-icon-copy-document"></gj-icon>
              </span>
            </el-col>
          </el-row>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {financeCurrencysOption, settlementReportType, financeProfitReportCurrency} from "@/utils/options";
  import SettlementImportRecord from './settlement/settlement-import-record';
  import SettlementImport from './settlement/settlement-import';
  import SettlementExport from './settlement/settlement-export';
  import {SET_OPEN_IMPORT} from "@/store/mutation-types";
  import {queryMixin} from "@/minxins";
  import {
    exportFinanceProfitReportSettlement,
    getFinanceProfitReportSettlement,
    getSettlementFeeType
  } from "@/api/finance";
  import {subDays} from "date-fns";
  import {convertToDate} from "@/utils/date.util";
  import {mapGetters} from "vuex";

  export default {
    name: "finance-profit-report-settlement",
    mixins: [queryMixin],
    computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
    },
    inject: ["getFilter", "setFilter"],
    created() {
      getSettlementFeeType().then((data) => {
        this.feeTypeOption = data
        this.$gjNoticeQuery()
      });
    },
    data() {
      return {
        tableName: 'financeProfitReportSettlement_v1',
        filter: {},
        financeProfitReport: financeCurrencysOption,
        settlementReportType: settlementReportType,
        feeTypeOption: [],
        data: [],
        keywordOptions: [
          {id: 'msku', text: 'MSKU',},
          {id: 'asin', text: 'ASIN',},
          {id: 'productName', text: '产品名称',},
          {id: 'sku', text: 'SKU',},
          {id: 'orderId', text: '订单号',},
          {id: 'desc', text: '描述',},
        ],
        columns: [
          {
            id: 'market',
            field: 'option:marketId',
            header: '店铺/国家',
            minWidth: '120px',
            disabled: true,
            default: true,
            fixed: 'left',
            options: () => this.marketOption
          },
          {
            id: 'standardDate',
            field: 'standardDate',
            header: '报表时间',
            minWidth: '150px',
            disabled: true,
            default: true,
            fixed: 'left'
          },
          {id: 'settlementId', field: 'settlementId', header: '结算ID', minWidth: '150px', default: true},
          {
            id: 'orderType',
            field: 'option:orderType',
            header: '报表类型',
            minWidth: '150px',
            default: true,
            options: settlementReportType
          },
          {id: 'type', field: 'type', header: '费用类型', minWidth: '150px', default: true},
          {id: 'orderId', field: 'orderId', header: '亚马逊订单编号', overflowLine: 2, minWidth: '150px', default: true},
          {id: 'msku', field: 'msku', header: 'MSKU', minWidth: '150px', default: true, copyable: true},
          {id: 'asin', field: 'asin', header: 'ASIN', minWidth: '150px', default: true, copyable: true,},
          {id: 'productName', field: 'slot:productName', header: '产品名称/SKU', minWidth: '160px', default: true},
          {id: 'categoryName', field: 'categoryName', header: '品类', minWidth: '150px', default: true},
          {id: 'description', field: 'slot:description', header: '描述', minWidth: '150px', default: true},
          {id: 'quantity', field: 'quantity', header: '数量', minWidth: '150px', default: true},
          {id: 'marketplace', field: 'marketplace', header: '市场', minWidth: '150px', default: true},
          {id: 'fulfillment', field: 'fulfillment', header: '配送类型', minWidth: '150px', default: true},
          {id: 'taxCollectionModel', field: 'taxCollectionModel', header: '税收征管模式', minWidth: '150px', overflowLine: 2, default: true},
          {
            id: 'productSales',
            field: 'productSales',
            header: '售价',
            minWidth: '150px',
            default: true,
            prefix: 'currencySymbol'
          },
          {
            id: 'productSalesTax',
            field: 'productSalesTax',
            header: '商品销售税',
            minWidth: '150px',
            default: true,
            prefix: 'currencySymbol'
          },
          {
            id: 'collectionVat',
            field: 'collectionVat',
            header: '增值税',
            minWidth: '150px',
            default: true,
            prefix: 'currencySymbol'
          },
          {
            id: 'shippingCredits',
            field: 'shippingCredits',
            header: '运费',
            minWidth: '150px',
            default: true,
            prefix: 'currencySymbol'
          },
          {
            id: 'shippingCreditsTax',
            field: 'shippingCreditsTax',
            header: '运费税',
            minWidth: '150px',
            default: true,
            prefix: 'currencySymbol'
          },
          {
            id: 'giftWrapCredits',
            field: 'giftWrapCredits',
            header: '礼品包装费',
            minWidth: '150px',
            default: true,
            prefix: 'currencySymbol'
          },
          {
            id: 'giftWrapCreditsTax',
            field: 'giftWrapCreditsTax',
            header: '礼品包装费税',
            minWidth: '150px',
            default: true,
            prefix: 'currencySymbol'
          },
          {
            id: 'promotionalRebates',
            field: 'promotionalRebates',
            header: '促销折扣',
            minWidth: '150px',
            default: true,
            prefix: 'currencySymbol'
          },
          {
            id: 'promotionalRebatesTax',
            field: 'promotionalRebatesTax',
            header: '促销折扣税',
            minWidth: '150px',
            default: true,
            prefix: 'currencySymbol'
          },
          {
            id: 'marketplaceWithheldTax',
            field: 'marketplaceWithheldTax',
            header: '市场预估税',
            minWidth: '150px',
            default: true,
            prefix: 'currencySymbol'
          },
          {
            id: 'sellingFees',
            field: 'sellingFees',
            header: '销售佣金',
            minWidth: '150px',
            default: true,
            prefix: 'currencySymbol'
          },
          {
            id: 'fbaFees',
            field: 'fbaFees',
            header: '配送相关费用',
            minWidth: '150px',
            default: true,
            prefix: 'currencySymbol'
          },
          {
            id: 'otherTransactionFees',
            field: 'otherTransactionFees',
            header: '其他交易费用',
            minWidth: '150px',
            default: true,
            prefix: 'currencySymbol'
          },
          {id: 'pointsGranted', field: 'pointsGranted', header: '积分', minWidth: '150px', default: true},
          {
            id: 'tcscgst',
            field: 'tcscgst',
            header: 'TCS-CGST',
            minWidth: '150px',
            default: true,
            prefix: 'currencySymbol'
          },
          {
            id: 'tcssgst',
            field: 'tcssgst',
            header: 'TCS-SGST',
            minWidth: '150px',
            default: true,
            prefix: 'currencySymbol'
          },
          {
            id: 'tcsigst',
            field: 'tcsigst',
            header: 'TCS-IGST',
            minWidth: '150px',
            default: true,
            prefix: 'currencySymbol'
          },
          {id: 'other', field: 'other', header: '其他', minWidth: '150px', default: true},
          {id: 'total', field: 'total', header: '总计', minWidth: '150px', default: true},
        ],
        useCache: false,
        notStorage: true
      }
    },
    methods: {
      $gjQuery() {
        this.loading = true;
        const params = {
          model: {
            ...this.filter,
            startDate: convertToDate(this.filter.date[0]),
            endDate: convertToDate(this.filter.date[1]),
          },
          ...this.queryPagination,
          ...this.querySort
        };
        params.model[this.filter.keyword.key] = this.filter.keyword.value;
        if (this.filter.countryAndMarket) {
          params.model.marketIds = this.filter.countryAndMarket.marketIds;
          params.model.countryIds = this.filter.countryAndMarket.countryIds;
        }
        this.globalParams = params;
        getFinanceProfitReportSettlement(params)
          .then((result) => {
            this.data = result.records;
            this.pagination = this.getPagination(result);
          }).complete(() => this.loading = false)
      },
      $gjQueryInitParams() {
        return {
          filter: {
            countryAndMarket: null,
            currency: '',
            keyword: {
              key: 'msku',
              value: null,
            },
            type: null,
            category: null,
            date: [subDays(new Date(), 14), new Date()],
          }
        }
      },
      /**
       *
       * @param params 查询条件参数
       * @override queryMixin
       * @returns {{ countryAndMarket: *}}
       */
      $gjCacheCallback(params) {
        return {
          countryAndMarket: params.countryAndMarket
        };
      },
      openImportRecord() {
        const modal = this.$gjCreate(SettlementImportRecord, {
          on: {
            importFileSuccess: () => {
              this.$gjResetPage();
            },
            importSuccess: () => {
              modal.$gjDestroy();
            }
          }
        })
      },
      openImport() {
        this.$store.commit(SET_OPEN_IMPORT,true)
        this.$router.push('/statistics/date-range-report')
        // const modal = this.$gjCreate(SettlementImport, {
        //   on: {
        //     importFileSuccess: () => {
        //       this.$gjResetPage();
        //     },
        //     importSuccess: () => {
        //       modal.$gjDestroy();
        //     }
        //   }
        // })
      },
      clickDownload() {
        exportFinanceProfitReportSettlement(this.globalParams)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import 'common';
</style>
